import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { ForgotPassword, LogIn, MemberLogin, ResetPassword } from '#/pages/auth';
import { PrivacyPolicy, TermsAndConditions } from '#/pages/footer';
import { Home } from '#/pages/home';
import Layout from '#/pages/layout/components/Layout';
import { MyContacts } from '#/pages/myContacts';
import { ProfileMain } from '#/pages/profile';
import { Unauthorized } from '#/pages/unauthorized';
import { PrivateRoute, ROUTES } from '.';

const createPrivateRoute = Component => {
    return (
        <PrivateRoute>
            <Component />
        </PrivateRoute>
    );
};

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path={ROUTES.LOGIN} element={<LogIn />} />
            <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
            <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
            <Route path={ROUTES.ACCEPT_INVITE} element={<MemberLogin />} />
            <Route path={ROUTES.ACCEPT_THRIVE_CART_INVITE} element={<MemberLogin isThriveCart={true} />} />

            <Route path={ROUTES.DEFAULT} element={createPrivateRoute(Layout)}>
                <Route index element={<Home />} />
                <Route path={ROUTES.HOME} element={<Home />} />
                <Route path={ROUTES.PROFILE} element={<ProfileMain />} />
                <Route path={ROUTES.MY_CONTACTS} element={<MyContacts />} />
                <Route path={ROUTES.TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
                <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />
            </Route>
            <Route path={ROUTES.UN_AUTHORIZED} element={<Unauthorized />} />
        </>
    ),
    { basename: '/app' }
);
